"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_plotly_js_1 = __importDefault(require("react-plotly.js"));
const ProbabilityVisualization = () => {
    const [mean, setMean] = (0, react_1.useState)(0);
    const [stdDev, setStdDev] = (0, react_1.useState)(1);
    const [sampleSize, setSampleSize] = (0, react_1.useState)(1000);
    // Generate normal distribution data
    const generateNormalData = (0, react_1.useMemo)(() => {
        const data = [];
        for (let i = 0; i < sampleSize; i++) {
            const u1 = Math.random();
            const u2 = Math.random();
            const z0 = Math.sqrt(-2 * Math.log(u1)) * Math.cos(2 * Math.PI * u2);
            data.push(z0 * stdDev + mean);
        }
        return data;
    }, [mean, stdDev, sampleSize]);
    // Generate properly scaled PDF curve
    const generatePDF = (0, react_1.useMemo)(() => {
        const x = [];
        const y = [];
        const min = mean - 4 * stdDev;
        const max = mean + 4 * stdDev;
        const step = (max - min) / 100;
        // Calculate proper scaling factor
        const binWidth = (max - min) / 30; // Match histogram bins
        const scaleFactor = sampleSize * binWidth;
        for (let i = min; i <= max; i += step) {
            x.push(i);
            const pdfValue = (1 / (stdDev * Math.sqrt(2 * Math.PI))) *
                Math.exp(-0.5 * Math.pow((i - mean) / stdDev, 2));
            y.push(pdfValue * scaleFactor);
        }
        return { x, y };
    }, [mean, stdDev]);
    console.log('PDF values:', generatePDF.y.slice(0, 5)); // Debug first few values
    return (react_1.default.createElement("div", { className: "probability-visualization", style: { padding: '20px' } },
        react_1.default.createElement("div", { className: "visualization-header" },
            react_1.default.createElement("h1", null, "Normal Distribution"),
            react_1.default.createElement("p", null, "Explore how mean and standard deviation affect the shape of the normal curve.")),
        react_1.default.createElement("div", { className: "controls", style: {
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                gap: '20px',
                marginBottom: '30px'
            } },
            react_1.default.createElement("div", { className: "control-group", style: { background: '#1e293b', padding: '15px', borderRadius: '8px' } },
                react_1.default.createElement("label", { style: { display: 'block', marginBottom: '8px', fontWeight: '500' } },
                    "Mean (\u03BC): ",
                    mean.toFixed(1),
                    " (Range: -5 to 5)"),
                react_1.default.createElement("input", { type: "range", min: "-5", max: "5", step: "0.1", value: mean, onChange: (e) => setMean(parseFloat(e.target.value)), style: { width: '100%' } }),
                react_1.default.createElement("div", { style: { display: 'flex', justifyContent: 'space-between', marginTop: '4px', fontSize: '0.8em' } },
                    react_1.default.createElement("span", null, "-5"),
                    react_1.default.createElement("span", null, "0"),
                    react_1.default.createElement("span", null, "5"))),
            react_1.default.createElement("div", { className: "control-group", style: { background: '#1e293b', padding: '15px', borderRadius: '8px' } },
                react_1.default.createElement("label", { style: { display: 'block', marginBottom: '8px', fontWeight: '500' } },
                    "Standard Deviation (\u03C3): ",
                    stdDev.toFixed(1)),
                react_1.default.createElement("input", { type: "range", min: "0.1", max: "3", step: "0.1", value: stdDev, onChange: (e) => setStdDev(parseFloat(e.target.value)), style: { width: '100%' } })),
            react_1.default.createElement("div", { className: "control-group", style: { background: '#1e293b', padding: '15px', borderRadius: '8px' } },
                react_1.default.createElement("label", { style: { display: 'block', marginBottom: '8px', fontWeight: '500' } },
                    "Sample Size: ",
                    sampleSize),
                react_1.default.createElement("input", { type: "range", min: "100", max: "10000", step: "100", value: sampleSize, onChange: (e) => setSampleSize(parseInt(e.target.value)), style: { width: '100%' } }))),
        react_1.default.createElement(react_plotly_js_1.default, { data: [
                {
                    x: generateNormalData,
                    type: 'histogram',
                    name: 'Random Samples',
                    nbinsx: 30,
                    opacity: 0.7,
                    marker: {
                        color: '#6366f1',
                        line: {
                            color: '#0f172a',
                            width: 1
                        }
                    }
                },
                {
                    x: generatePDF.x,
                    y: generatePDF.y,
                    type: 'scatter',
                    mode: 'lines',
                    name: 'Theoretical PDF',
                    line: {
                        color: '#f59e0b',
                        width: 3
                    }
                }
            ], layout: {
                title: {
                    text: 'Normal Distribution',
                    font: { size: 24 }
                },
                xaxis: {
                    title: 'Value',
                    gridcolor: '#334155'
                },
                yaxis: {
                    title: 'Relative Frequency',
                    gridcolor: '#334155'
                },
                paper_bgcolor: 'rgba(0,0,0,0)',
                plot_bgcolor: 'rgba(0,0,0,0)',
                font: { color: '#e5e7eb', family: 'Inter' },
                margin: { l: 80, r: 40, t: 80, b: 80 },
                legend: {
                    x: 1,
                    xanchor: 'right',
                    y: 1,
                    bgcolor: 'rgba(30, 41, 59, 0.8)'
                },
                hovermode: 'x unified'
            }, config: {
                responsive: true,
                displaylogo: false,
                modeBarButtonsToRemove: ['toImage']
            }, style: {
                width: '100%',
                height: '500px',
                background: '#1e293b',
                borderRadius: '12px',
                padding: '15px'
            } }),
        react_1.default.createElement("div", { className: "explanation", style: {
                marginTop: '40px',
                padding: '20px',
                background: '#1e293b',
                borderRadius: '8px'
            } },
            react_1.default.createElement("h3", { style: { marginBottom: '15px', color: '#f8fafc' } }, "What am I looking at?"),
            react_1.default.createElement("p", { style: { lineHeight: '1.6', color: '#e2e8f0' } },
                "This visualization shows a normal (Gaussian) distribution, one of the most important probability distributions in statistics. The ",
                react_1.default.createElement("span", { style: { color: '#6366f1' } }, "blue histogram"),
                " represents randomly generated data points following the distribution. The ",
                react_1.default.createElement("span", { style: { color: '#f59e0b' } }, "orange curve"),
                " shows the scaled theoretical probability density function (PDF) matching the histogram scale."),
            react_1.default.createElement("p", { style: { lineHeight: '1.6', color: '#e2e8f0', marginTop: '10px' } },
                react_1.default.createElement("strong", null, "Key concepts:"),
                react_1.default.createElement("br", null),
                "\u2022 ",
                react_1.default.createElement("strong", null, "Mean (\u03BC)"),
                ": Center of the distribution",
                react_1.default.createElement("br", null),
                "\u2022 ",
                react_1.default.createElement("strong", null, "Standard Deviation (\u03C3)"),
                ": Spread of the distribution",
                react_1.default.createElement("br", null),
                "\u2022 ",
                react_1.default.createElement("strong", null, "Sample Size"),
                ": Number of random points generated",
                react_1.default.createElement("br", null),
                "As you adjust the parameters, watch how the shape of the distribution changes."))));
};
exports.default = ProbabilityVisualization;
